//Event will fire when we click on "Add to Box" button of product card
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-product-card-add-to-box]');
  if (!btn) return;

  const type = btn.dataset.type; // 'add-on', 'deal'

  const eventName =
    {
      'add-on': 'Addon Quantity Increased',
      deal: 'Member Deal Quantity Increased',
    }[type] || 'Product Added';

  analytics.track(eventName, {
    variant_id: btn.dataset.variantId,
    product_id: btn.dataset.productId,
    sku: btn.dataset.productSku,
    name: btn.dataset.productName,
    price: parseFloat(btn.dataset.productPrice),
    quantity: 1,
    quantity_delta: 1,
    total_delta: parseFloat(btn.dataset.productPrice) * 1,
    total: parseFloat(btn.dataset.productPrice) * 1,
    type: type,
  });
});

//Event will fire when we click add or minus quantity buttons of product card
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-action="add"], [data-action="minus"]');
  if (!btn) return;

  const card = btn.closest('product-card');
  if (!card) return;

  const addToBoxBtn = card.querySelector('[data-product-card-add-to-box]');
  if (!addToBoxBtn) return;

  const type = addToBoxBtn.dataset.type;
  const action = btn.dataset.action;
  const currentQuantity = parseInt(card.querySelector('[data-quantity-input]')?.value);
  const quantityDelta = action === 'add' ? 1 : -1;
  const newQuantity = currentQuantity + quantityDelta;
  const price = parseFloat(addToBoxBtn.dataset.productPrice);

  let eventName;
  if (type === 'deal') {
    eventName = action === 'add' ? 'Member Deal Quantity Increased' : 'Member Deal Quantity Reduced';
  } else if (type === 'add-on') {
    eventName = action === 'add' ? 'Addon Quantity Increased' : 'Addon Quantity Reduced';
  } else {
    eventName = action === 'add' ? 'Product Added' : 'Product Removed';
  }

  analytics.track(eventName, {
    variant_id: addToBoxBtn.dataset.variantId,
    product_id: addToBoxBtn.dataset.productId,
    sku: addToBoxBtn.dataset.productSku,
    name: addToBoxBtn.dataset.productName,
    price: price,
    quantity: Math.max(0, newQuantity),
    quantity_delta: quantityDelta,
    total: price * Math.max(0, newQuantity),
    total_delta: price * quantityDelta,
    type: type,
  });
});

async function trackCheckoutMarketingOptIn(email) {
  const selectedTile = document.querySelector('[data-offer-tile].selected');
  const discountCode = document.querySelector('[data-reference-input]')?.value;

  const offerDetails = {
    id: selectedTile?.dataset.offerProductId || '',
    sku: selectedTile?.dataset.offerSku || '',
    title: selectedTile?.querySelector('[id^="offer-title"]')?.textContent?.trim() || selectedTile?.dataset.offerTitle || '',
  };

  // ─── Set localStorage ───
  window.localStorage.setItem('subscriptionBuilderSelectedOfferDetails', JSON.stringify(offerDetails));

  if (email) {
    var anonymousId = document.cookie
      .split('; ')
      .find(function (row) {
        return row.startsWith('ajs_anonymous_id=');
      })
      ?.split('=')[1];

    await new Promise((resolve) => {
      analytics.identify({ email: email }, { anonymousId: decodeURIComponent(anonymousId) }, resolve);
    });
  }

  const queryParams = new URLSearchParams(window.location.search);
  analytics.track('Checkout Marketing Opt In', {
    offer_variant_id: selectedTile?.dataset.variantId,
    offer_description: offerDetails.title,
    offer_id: offerDetails.id,
    offer_sku: offerDetails.sku,
    path: window.location.pathname,
    url: window.location.href,
    domain: window.location.hostname,
    email: email,
    discount_code: discountCode || null,
    utmCampaign: queryParams.get('utm_campaign') ?? undefined,
    utmContent: queryParams.get('utm_content') ?? undefined,
    utmMedium: queryParams.get('utm_medium') ?? undefined,
    utmSource: queryParams.get('utm_source') ?? undefined,
    utmTerm: queryParams.get('utm_term') ?? undefined,
  });

  analytics.track('Cart Updated', {
    url: window.location.href,
    plan_name: null,
    plan_type: null,
    plan_frequency_weeks: null,
    plan_size: null,
    offer_variant_id: selectedTile?.dataset.variantId,
    offer_sku: offerDetails.sku,
    offer_id: offerDetails.id,
    offer_banner_description: offerDetails.title ?? null,
    products: [],
    discount_code: discountCode || null,
  });
}

const EMAIL_VALIDATION_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

function isValidEmail(email) {
  return typeof email === 'string' && EMAIL_VALIDATION_REGEX.test(email.trim());
}

// ─── Email form button on a lander ───
document.addEventListener('submit', async function (e) {
  const form = e.target.closest('#newsletter-form');
  if (!form) return;
  const email = form.querySelector('input[type="email"]')?.value;
  if (!isValidEmail(email)) return;
  await trackCheckoutMarketingOptIn(email.trim());
});

// ─── Direct link button on a lander ───
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('[data-submit]');
  if (btn) await trackCheckoutMarketingOptIn(null);
});

// Products Viewed Event
const viewedProductQueue = [];
let viewedProductTimer = null;

function flushViewedProducts() {
  if (!viewedProductQueue.length) return;

  analytics.track('Products Viewed', {
    products: [...viewedProductQueue],
  });

  viewedProductQueue.length = 0; // clear queue like setEventQueue([])
}

const observer = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const card = entry.target;
      const btn = card.querySelector('[data-product-card-add-to-box]');
      if (!btn) return;

      viewedProductQueue.push({
        shopify_product_variant_id: btn.dataset.variantId,
        shopify_product_id: btn.dataset.productId,
        sku: btn.dataset.productSku,
        product_type: btn.dataset.productType,
        ts: Math.floor(Date.now() / 1000),
      });

      // ─── setInterval equivalent - reset every 2s ───
      clearTimeout(viewedProductTimer);
      viewedProductTimer = setTimeout(flushViewedProducts, 2000);
    });
  },
  { threshold: 0.5 }
);

// observe all product cards
document.querySelectorAll('product-card').forEach((card) => {
  observer.observe(card);
});
